import request from 'ynf-core-engine/request';
import { configHook } from '@utils';
import { requiredValidate } from "../utils";
import { bNeedRefresh } from '../navigate';

export async function cancelBusinessTasks(rootStore: any, options: any = {}) { 
  requiredValidate.call(this, options, ['cardStoreKey']);
  const { cardStoreKey = 'cardStore', requestUrl= `${_YPD_SERVICE_}/bill/eeacreverse`, data} = options
  const cardStore = rootStore.get(cardStoreKey);
  const { query = { }, params = { } } = rootStore.pageStore
  if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
  const value = cardStore.getValue() || {}
  value._status = 'Update'
  const option = {
    params: {
      ...query,
      busiObj: options?.busiObj || query?.busiObj,
      billnum: options?.busiObj || params?.billNo,
      datasource: options?.dataSourceAlias || cardStore?.dataSource
    },
    data: data || { data: JSON.stringify(value) },
    method: 'post',
    requestUrl
  }
    try {
    rootStore.pageStore?.startLoading?.();
    const res = await configRequest(rootStore, option)
    rootStore.utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_19E5D01A04180006', '正在取消过账'));
    bNeedRefresh.apply(this, arguments);
      return res
  } catch (error) {
    rootStore.utils.message.danger(lang.localeUuid('UID:P_CORE-YNF-FE_19E5D06404180009', { message: error?.message }));
  } finally {
    rootStore.pageStore?.endLoading?.();
  }
}

export async function generateBusinessTasks(rootStore: any, options: any = {}) { 
  requiredValidate.call(this, options, ['cardStoreKey']);
  const { cardStoreKey = 'cardStore', requestUrl= `${_YPD_SERVICE_}/bill/eeacsend`, data} = options
  const cardStore = rootStore.get(cardStoreKey);
  const { query = { }, params = { } } = rootStore.pageStore
  if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
  const value = cardStore.getValue() || {}
  value._status = 'Update'
  const option = {
    params: {
      ...query,
      busiObj: options?.busiObj || query?.busiObj,
      billnum: options?.busiObj || params?.billNo,
      datasource: options?.dataSourceAlias || cardStore?.dataSource
    },
    data: data || { data: JSON.stringify(value) },
    method: 'post',
    requestUrl
  }
    try {
    rootStore.pageStore?.startLoading?.();
    const res = await configRequest(rootStore, option)
    rootStore.utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_19DC09D605880001', '正在过账中'));
    bNeedRefresh.apply(this, arguments);
    return res
  } catch (error) {
    rootStore.utils.message.danger(lang.localeUuid('UID:P_CORE-YNF-FE_19DC0B8005A80005', { message: error?.message }));
  } finally {
    rootStore.pageStore?.endLoading?.();
  }
}

export async function configRequest(rootStore: any, options: any = {}) {
  const { requestUrl = '', method = '', params = {}, data = {}, ...rest } = options
  /**
   * 默认查询参数
  */
  const defaultQuery = {
    params: {
      feV: 6,
    },
    data: {

    }
  };
  defaultQuery.params = configHook(params, defaultQuery.params);
  defaultQuery.data = configHook(data, defaultQuery.data);
  try {
    const res = await request({
      url: requestUrl,
      method,
      ...defaultQuery,
      ...rest
    });
    return res;
  } catch (err) {
    return Promise.reject(err);
  }
}